import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "m6.115 5.195.319 1.913a6 6 0 0 0 1.676 3.256l1.64 1.64-.387.775c-.217.434-.132.957.21 1.299l1.348 1.347c.21.211.329.497.329.796v1.088c0 .426.24.816.622 1.007l.153.076c.433.217.956.132 1.298-.21l.723-.723a8.7 8.7 0 0 0 2.288-4.042 1.09 1.09 0 0 0-.358-1.1l-1.33-1.107c-.251-.21-.582-.3-.905-.246l-1.17.195a1.13 1.13 0 0 1-.98-.314l-.295-.295a1.125 1.125 0 0 1 0-1.59l.13-.132a1.125 1.125 0 0 1 1.3-.21l.603.301a.809.809 0 0 0 1.086-1.085l-.165-.33 1.256-.836a4.5 4.5 0 0 0 1.528-1.732l.146-.292m-11.065.551a9 9 0 1 0 11.065-.551m-11.065.551A8.97 8.97 0 0 1 12 3.005c1.929 0 3.716.606 5.18 1.64"
    }, null, -1)
  ])))
}
export default { render: render }